/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Footer from '../components/Footer';
import Header from '../components/Header';
import MobileSideMenu from '../components/MobileSideMenu';
import useWake from '../helpers/useWakeServer';

function ContactUs() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isWaking, wakeServer, shouldWakeServer } = useWake();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    comment: '',
  });

  const formControlIds = {
    firstName: 'first-name',
    lastName: 'last-name',
    email: 'email-address',
    comment: 'comment',
  };

  function toggleMobileMenuOpen() {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  function successNotify(msg, id) {
    toast.success(msg, {
      toastId: id,
    });
  }

  function errorNotify(msg, id) {
    toast.error(msg, {
      toastId: id,
    });
  }

  const validateForm = (data) => {
    const isFormValid =
      data.firstName.trim() &&
      data.lastName.trim() &&
      data.email.trim() &&
      /\S+@\S+\.\S+/.test(data.email);
    setFormValid(isFormValid);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    validateForm(updatedFormData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formValid || isSubmitting) return;

    setIsSubmitting(true);

    try {
      if (shouldWakeServer()) {
        await wakeServer();
      }

      const response = await fetch(
        'https://gartekweb.onrender.com/contact-us',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: `${formData.lastName} ${formData.firstName}`,
            email: formData.email,
            message: formData.comment,
          }),
        }
      );

      if (response.ok) {
        successNotify('Message sent successfully!', 1);
        setFormData({ firstName: '', lastName: '', email: '', comment: '' });
        setFormValid(false);
      } else {
        errorNotify('Failed to send message. Please try again.', 2);
      }
    } catch (err) {
      errorNotify('An error occurred. Please try again later.', 3);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <MobileSideMenu open={mobileMenuOpen} toggleOpen={toggleMobileMenuOpen} />
      <Header toggleMobileMenu={toggleMobileMenuOpen} />
      <main className="md:flex md:justify-center">
        <section className="p-3 my-8 w-full md:w-3/4 max-w-2xl flex flex-col gap-8">
          <div>
            <h1 className="mb-4 font-extrabold text-3xl">Send Us a Message</h1>
            <p className="text-lg">
              You can reach out to us via our official email <br />
              <a href="mailto:gartekcloude@gmail.com" className="text-gold">
                gartekcloude@gmail.com
              </a>
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="rounded-xl bg-white-variant p-6 gap-5 flex flex-col"
          >
            <div className="flex flex-col gap-6">
              <label
                htmlFor={formControlIds.firstName}
                className="font-semibold"
              >
                First Name <span className="star">*</span>
              </label>
              <input
                className="text-base border-0 rounded-lg py-4 px-3"
                type="text"
                name="firstName"
                id={formControlIds.firstName}
                required
                placeholder="Enter your first name"
                value={formData.firstName}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-col gap-6">
              <label
                htmlFor={formControlIds.lastName}
                className="font-semibold"
              >
                Last Name <span className="star">*</span>
              </label>
              <input
                className="text-base border-0 rounded-lg py-4 px-3"
                type="text"
                name="lastName"
                id={formControlIds.lastName}
                required
                placeholder="Enter your last name"
                value={formData.lastName}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-col gap-6">
              <label htmlFor={formControlIds.email} className="font-semibold">
                Email Address <span className="star">*</span>
              </label>
              <input
                className="text-base border-0 rounded-lg py-4 px-3"
                type="email"
                name="email"
                id={formControlIds.email}
                required
                placeholder="Enter a verified Email Address"
                value={formData.email}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-col gap-6">
              <label htmlFor={formControlIds.comment} className="font-semibold">
                Comment
              </label>
              <textarea
                name="comment"
                id={formControlIds.comment}
                placeholder="Type a message"
                cols="30"
                rows="6"
                className="text-base border-0 rounded-lg py-4 px-3 resize-none overflow-auto"
                value={formData.comment}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex my-5 justify-center items-center">
              <button
                className={`bg-gold rounded-md text-white text-lg font-bold py-4 px-6 ${
                  formValid
                    ? 'border-gold'
                    : 'opacity-35 border-gray-400 cursor-not-allowed'
                }`}
                type="submit"
                disabled={!formValid || isSubmitting || isSubmitting}
              >
                {isSubmitting || isWaking ? 'Sending...' : 'Send Message'}
              </button>
            </div>
          </form>
        </section>
      </main>
      <Footer />
      <ToastContainer containerId={1} />
      <ToastContainer containerId={2} />
      <ToastContainer containerId={3} />
      <ToastContainer containerId={4} />
      <ToastContainer containerId={5} />
      <ToastContainer containerId={6} />
    </>
  );
}

export default ContactUs;
